<rules-editor [(rule)]="rule" placeholder="Formatter" [type]="types.ArraySelector" (updateRule)="updateRule($event)"></rules-editor> 